import React, {useEffect, useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button} from "@chakra-ui/react";
import Sheet, {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useCreateCardPayment} from "../../../api/payments";
import {loadStripe} from '@stripe/stripe-js/pure';
import useModal from "../../../modals";
import {useStoreProfile} from "../../../store";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "../../payments/checkout_form";
import {useSheetModal} from "../../test/ModalContext";
import CardPaymentSuccessSheet from "./card_payment_success";

const ButtonContainer = styled.div``;
const Terms = styled.div``;

const ProCardPaymentSheet = styled(({className, type, tier = 0, length = 0, awards = 0, overridePrice, onClose}) => {

    const stripePromise = loadStripe("pk_live_51Lb99DBskTIWjE9dBIDuIb0NmRSKwHIhvoovmiYALJGoD7b46iJgiGxWDyt8MuToWkV4ZnM8rsTMvm6KtrWB84QI00edqppcYV");

    const modal = useModal();
    const price = type === "award" ? 3.99 * awards : overridePrice;
    const {error, feedbackCh} = useFeedback();
    const [success, setSuccess] = useState(false);
    const [saved, setSaved] = useState(0);
    const cardPayment = useCreateCardPayment(feedbackCh, type, tier, awards, price);
    const id = cardPayment?.token;

    const {theme} = useStoreProfile();
    const appearance = {
        theme: "stripe",
        variables: {
            colorPrimary: '#0570de',
            colorBackground: `${theme === 'dark' ? '#1a1a1b' : '#fff'}`,
            colorText: `${theme === 'dark' ? '#fff' : '#000'}`,
        }
    };
    const options = {
        // passing the client secret obtained from the server
        clientSecret: id,
        appearance,
    };

    const handleClick = () => {
        setSaved(Date.now());
    };

    const { openModal } = useSheetModal();
    useEffect(() => {
        if (success) {

            const modalContent = ( ) => (
                <Sheet onClose={() => onClose() }  padding={"header"}><CardPaymentSuccessSheet type={"subscription"} tier={tier === "basic" ? 1 : 2} length={length} overridePrice={price} onClose={() => onClose() } /></Sheet>
            );

            openModal(modalContent);

        }
    }, [success]);

        return (
            <div className={className}>

                <Header>
                    <Title>Send Payment</Title>
                </Header>

                <div style={{margin: '0 0 12px'}}>
                    {id ?
                        <Elements stripe={stripePromise} options={options} >
                            <CheckoutForm saved={saved} setSuccess={setSuccess}/>
                        </Elements>
                        :
                        <>Loading...</>
                    }
                </div>

                <Terms>By placing your order, you are signing up to a {type === "award" ? "one time payment" : "recurring monthly charge"} of ${price} USD, and agreeing to our Terms of Service.</Terms>

                <ButtonContainer>
                    <Button variant={"blue"} w={"100%"} onClick={handleClick}>Pay</Button>
                </ButtonContainer>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
  }
  ${Terms} {
    font-size: 15px;
    margin: 16px 0;
  }
`;

export default ProCardPaymentSheet;
